<template>
	<div>
		<!-- {{ localCandidateInfo.achievement.achieveType }} -->
		<div class="d-flex align-items-center mt-2">
			<div
				class=""
				:class="isLaptop ? 'mr-3 ' : ''"
				v-if="!achievement.parser && $route.name == 'CandidateDashboard'"
			>
				<img
					class="drag-handleAch"
					src="../../../assets/newdesign/dashboard/6dots.svg"
					alt=""
				/>
			</div>
			<div
				class="p-2 position-relative mob-align-items-start"
				:class="{
					'candash-red-details-box': achievement.parser,
					'candash-blue-details-nowid': !achievement.parser,
					'resume-builder-card-width':
						!achievement.parser && $route.name === 'CandidateDashboard',
					'w-100': achievement.parser || $route.name !== 'CandidateDashboard',
				}"
			>
				<div
					@click="
						openInsideProCerti[achievement.uniqueID] =
							!openInsideProCerti[achievement.uniqueID]
					"
					class="d-flex pointer mob-align-items-start w-100"
				>
					<img
						class="mr-3 lapicon"
						src="../../../assets/newdesign/dashboard/skillDp.svg"
						alt=""
					/>
					<img
						class="mr-2 mobicon"
						src="@/assets/newbuilder/mob-skills.svg"
						alt=""
					/>
					<div class="mob-w-88 w-100 d-flex justify-content-between">
						<div class="mob-w-95 w-75 text-capitalize">
							<div
								class="d-contents align-items-center bold-bluetxt mr-5 mobmr-0 gap-4"
								:class="achievement.title ? '' : 'not-mention-txt'"
							>
								{{ achievement.title ? achievement.title : "Not Mentioned" }}
								<img
									v-if="achievement.link"
									class="pointer hideinmob"
									src="../../../assets/newdesign/dashboard/blueChain.svg"
									alt=""
									@click.stop="redirectToTheLink(achievement.link)"
								/>
								<img
									@click.stop="downloadAchievementFile(achievement)"
									v-if="
										achievement.uploadFile != null &&
										achievement.uploadFile != ''
									"
									class="pointer"
									src="../../../assets/newdesign/dashboard/download (2).svg"
									alt=""
								/>
							</div>
							<div
								:class="
									isLaptop
										? ' '
										: 'd-flex align-items-center justify-content-between mt-1'
								"
							>
								<div
									:class="{
										'mt-2': isLaptop,
										'not-mention-txt': !achievement.issuingOrganization,
									}"
									class="w-60 text-truncate js-description-font"
								>
									{{
										achievement.issuingOrganization
											? achievement.issuingOrganization
											: "Not Mentioned"
									}}
								</div>
								<div
									v-if="!openInsideProCerti[achievement.uniqueID]"
									class="mobile-view-more-txt text-blue hideinlaptop white-space-no-wrap"
									@click.stop="
										openInsideProCerti[achievement.uniqueID] =
											!openInsideProCerti[achievement.uniqueID]
									"
								>
									View more
									<img
										class="ml-1 mobrotate-180"
										src="@/assets/job-search-icons/mob-uparrow.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
						<div class="pt-2 pr-2 laptop-ed-icons">
							<img
								@click.stop="openEdit()"
								class="mr-2 pointer blueShadow"
								src="../../../assets/newdesign/dashboard/blueEdit1.svg"
								alt=""
							/>
							<img
								@click.stop="deleteData()"
								src="../../../assets/newdesign/dashboard/blueDelete1.svg"
								alt=""
								class="mr-2 pointer blueShadow"
							/>
							<img
								v-if="achievement.parser"
								class="mr-2"
								@click.stop
								src="../../../assets/newdesign/dashboard/disableadd.svg"
								alt=""
							/>
							<img
								v-if="!openInsideProCerti[achievement.uniqueID]"
								src="../../../assets/newdesign/dashboard/whiteBlueDown.svg"
								alt=""
								class="pointer blueShadow"
							/>
							<img
								v-else
								src="../../../assets/newdesign/dashboard/whiteBlueUp.svg"
								alt=""
								class="pointer blueShadow"
							/>
						</div>
						<div
							class="mobile-ed-icons"
							@click.stop="$emit('select-card', achievement.uniqueID)"
						>
							<img src="@/assets/newbuilder/threedots.svg" alt="" />
							<div
								class="ed-box"
								v-if="selectedCard == achievement.uniqueID"
								:ref="'cardopen' + achievement.uniqueID"
							>
								<div
									class="ed-box-option d-flex align-items-center pl-2 pointer"
									@click.stop="openEdit()"
								>
									<img
										src="@/assets/newbuilder/ddedit.svg"
										class="mr-2"
										alt=""
									/>Edit
								</div>
								<div
									class="ed-box-option d-flex align-items-center pl-2 pointer"
									@click="deleteData()"
								>
									<img
										src="@/assets/newbuilder/delete.svg"
										class="mr-2"
										alt=""
									/>Delete
								</div>
							</div>
						</div>
					</div>
				</div>
				<b-collapse
					v-model="openInsideProCerti[achievement.uniqueID]"
					class="p-2"
				>
					<b-row class="mt-3">
						<b-col :cols="isLaptop ? '5' : '12'" class="mobmb-2">
							<div class="candash-displaytxt-grey">Issued Organization</div>
							<div
								class="candash-bold-grey mt-1"
								:class="
									achievement.issuingOrganization ? '' : 'not-mention-txt'
								"
							>
								{{
									achievement.issuingOrganization
										? achievement.issuingOrganization
										: "Not Mentioned"
								}}
							</div>
						</b-col>
						<b-col :cols="isLaptop ? '2' : '4'">
							<div class="candash-displaytxt-grey">Issued Date</div>
							<div
								class="candash-bold-grey mt-1"
								:class="achievement.issueDate ? '' : 'not-mention-txt'"
							>
								{{
									achievement.issueDate == null || achievement.issueDate == ""
										? "Not Mentioned"
										: formatDate(achievement.issueDate, "dd-MM-yyyy")
								}}
							</div>
						</b-col>

						<b-col
							v-if="achievement.achieveType == 'certificate'"
							:cols="isLaptop ? '3' : '4'"
							class="mobpl-0"
						>
							<div class="candash-displaytxt-grey">Certification ID</div>
							<div
								class="candash-bold-grey mt-1"
								:class="achievement.certificateID ? '' : 'not-mention-txt'"
							>
								{{
									achievement.certificateID
										? achievement.certificateID
										: "Not Mentioned"
								}}
							</div>
						</b-col>
					</b-row>
					<b-row
						class="mt-3"
						v-if="achievement.description || achievement.parser"
					>
						<b-col>
							<div
								class="candash-displaytxt-grey"
								v-if="achievement.description"
							>
								Description
							</div>
							<div
								class="candash-blackTxt word-break mt-1"
								:class="achievement.description ? '' : 'not-mention-txt'"
							>
								{{
									achievement.description
										? achievement.description
										: "Not Mentioned"
								}}
							</div>
						</b-col>
					</b-row>
					<div
						class="mobile-view-more-txt text-blue hideinlaptop d-flex justify-content-end w-100"
						@click.stop="
							openInsideProCerti[achievement.uniqueID] =
								!openInsideProCerti[achievement.uniqueID]
						"
					>
						View less
						<img
							class="ml-1"
							src="@/assets/job-search-icons/mob-uparrow.svg"
							alt=""
						/>
					</div>
				</b-collapse>
			</div>
		</div>
	</div>
</template>

<script>
import { formatDate } from "../../../controllers/dashboard/helpers.js";
export default {
	name: "AchievementCard",
	props: {
		selectedCard: String,
		achievement: Object,
		isLaptop: Boolean,
		formConfiguration: Object,
		form: Object,
	},
	data() {
		return {
			openInsideProCerti: {},
		};
	},
	mounted() {
		document.addEventListener("click", this.clickon);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.clickon);
	},
	methods: {
		formatDate(inputDate, format) {
			return formatDate(inputDate, format);
		},
		openEdit() {
			this.$emit("edit-form", {
				form: this.form,
				content: this.achievement,
				id: this.achievement.uniqueID,
				tab: this.achievement.achieveType,
			});
		},
		deleteData() {
			this.$emit("delete-data", {
				form: this.form,
				content: this.achievement,
			});
		},
		clickon() {
			let id = "cardopen" + this.achievement.uniqueID;
			if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
				this.$emit("select-card", "");
			}
		},
		redirectToTheLink(linkCopy) {
			const textarea = document.createElement("textarea");
			textarea.value = linkCopy;
			document.body.appendChild(textarea);
			textarea.select();
			document.body.removeChild(textarea);
			window.open(linkCopy, "_blank");
		},
		downloadAchievementFile(linkData) {
			const pathSegments = linkData.uploadFileLink.split("/");
			const fileName = pathSegments[pathSegments.length - 1];
			const link = document.createElement("a");
			link.href = linkData.uploadFileLink;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
	},
};
</script>

<style></style>
